import Avatar from '@material-ui/core/Avatar';
import Chip from '@material-ui/core/Chip';
import { withStyles } from '@material-ui/core/styles';
import PropTypes from 'prop-types';
import React from 'react';
import { globalStyles as styles } from './style/gstheme';

class BasicChip extends React.Component {

    render() {

        const { classes, label, onClick, onDelete, title, dataTest } = this.props;
        const active = onClick && onClick !== undefined;

        return (
            <Chip
                data-test={dataTest}
                color="primary"
                avatar={<Avatar style={{ backgroundColor: '#01579B' }}>{title || "G"}</Avatar>}
                clickable={active}
                onClick={onClick}
                onKeyDown={(ev) => {
                    if (active && ev.key === "Delete") {
                        ev.preventDefault();
                        ev.stopPropagation();
                        if (onDelete) onDelete();
                    }
                }}
                onDelete={onDelete}
                label={label}
                className={active ? classes.activeChip : classes.chip}
            />
        );
    }
}

BasicChip.propTypes = {
    dataTest: PropTypes.string,
    title: PropTypes.string,
    classes: PropTypes.object.isRequired,
    label: PropTypes.string.isRequired,
    onClick: PropTypes.func,
    onDelete: PropTypes.func
};

export default withStyles(styles)(BasicChip);